// SF4 — sales being left on the table.
//
// Most rows here carry no rupee figure, and none is invented to make them sort
// higher. What a gap would have earned cannot be measured from what was not
// spent, and a made-up number would corrupt every real one above it.
import React from 'react';
import s from '../AdsHealth.module.css';
import { money, TYPE_LABEL } from '../format';

function Sources({ sources }) {
  if (!sources) return null;
  const rows = [
    ['eligibility', 'Amazon eligibility'],
    ['budget', 'Budget usage'],
    ['stock', 'Stock'],
    ['buy_box', 'Buy Box'],
    ['suppression', 'Suppression'],
    ['price_history', 'Price history'],
    ['listing_quality', 'Listing quality'],
  ];
  return (
    <>
      <h3 className={s.sectionTitle}>What these checks could see</h3>
      <div className={s.sourceGrid}>
        {rows.map(([key, label]) => {
          const r = sources[key] || {};
          return (
            <div key={key} className={s.sourceItem}>
              <div className={s.sourceName}>
                <span className={`${s.sourceDot} ${r.available ? s.sourceDot_on : ''}`} />
                {label}
              </div>
              {(r.missing || r.note) && (
                <div className={s.sourceNote}>{r.missing || r.note}</div>
              )}
              {r.drd && <div className={s.sourceDrd}>{r.drd}</div>}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default function Gaps({ data, currency, findings }) {
  if (!data) return <p className={s.empty}>Loading…</p>;

  return (
    <div>
      {data.competition_note && <p className={s.coverage}>{data.competition_note}</p>}

      {!(findings || []).length ? (
        <p className={s.empty}>No coverage gap fired.</p>
      ) : (
        <div className={s.tableWrap}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>Gap</th><th>What</th><th className={s.right}>Worth</th><th>Why</th>
              </tr>
            </thead>
            <tbody>
              {findings.map((f) => (
                <tr key={f.id}>
                  <td>{TYPE_LABEL[f.type] || f.type}</td>
                  <td>{f.entity}</td>
                  <td className={s.right}>
                    {f.impact != null ? money(f.impact, currency)
                      : <span className={s.thin}>ranked by severity</span>}
                  </td>
                  <td className={s.thin} style={{ maxWidth: 500 }}>{f.evidence}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data.catalogue && (
        <p className={s.coverage}>
          {data.catalogue.candidates} products were considered for the unadvertised check.
          {data.catalogue.buyability_checked
            ? ' Buyability was confirmed against your listings.'
            : ` ${data.catalogue.missing || 'Buyability could not be confirmed.'}`}
        </p>
      )}

      <Sources sources={data.sources} />
    </div>
  );
}
